import {useQuery} from 'react-query';
import {getDogDestructivePhrases} from '../../api/dogDestructivePhrases';

export const useDogDestructivePhrase = () => {
    return useQuery("dogDestructivePhrase", () => getDogDestructivePhrases());
};
